import { Component, Input, OnInit } from '@angular/core';
import { HomeService } from 'src/app/_services/home.service';

@Component({
    selector: 'app-all-currencies',
    templateUrl: './all-currencies.component.html',
    styleUrls: ['./all-currencies.component.scss']
})
export class AllCurrenciesComponent implements OnInit {
    page: number = 0;
    total: number = 7000;
    btcTicketsAll: any;
    constructor(private homeService: HomeService) { }

    ngOnInit(): void {
        this.getCurrencies();
    }

    getCurrencies() {
        this.homeService.getBTCTicketsData(this.page, 20).then(data => {
            this.btcTicketsAll = data.Data;
            this.btcTicketsAll = this.btcTicketsAll.filter((x: any) => x.hasOwnProperty('DISPLAY'));
        })
    }

    pageChanged(event: any) {
        this.page = event;
        this.getCurrencies();
    }

}
